import React from 'react'
import PageTemplate from 'components/page-template'

const FacebookDashboard = () => (
  <PageTemplate
    title='Dashboard'
    description='latest activity & stats'
    noContainer
  >
    <div className='br-portlet-light'>
      <p className='font-blue-sharp bold uppercase'>
        Thanks for authorising your Facebook Account and providing us with the
        necessary permission to run the Instagram Experience for you.
      </p>
      <p>
        Our Activations team will setup the experience from here and no further
        action on this interface would be required from you.
      </p>
      <p>
        Please ensure that you were logged into Facebook with the account linked
        to the Instagram account that the experience will be running on
      </p>
    </div>
  </PageTemplate>
)

FacebookDashboard.displayName = 'Dashboard'

export default FacebookDashboard



// WEBPACK FOOTER //
// ./src/pages/fb-dashboard/index.js